import React from 'react'
import { Typography, Button, Tabs, theme } from 'antd'
import { PlusOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

import EventFilters from './EventFilters'
import EventsTable from './EventsTable'
import TimelineView from './TimelineView'
import AddEventModal from './AddEventModal'

import useEventData from '../hooks/useEventData'
import useModalState from '../hooks/useModalState'

const { Title } = Typography
const { TabPane } = Tabs

const TheatreRoomEventsList = () => {
  const { token } = theme.useToken()

  const {
    searchText,
    setSearchText,
    roomFilter,
    setRoomFilter,
    eventTypeFilter,
    setEventTypeFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange,
    theatreRooms,
    eventTypes,
    eventCategories,
    filteredData
  } = useEventData()

  const { isModalVisible, form, showModal, handleCancel, handleAdd } = useModalState()

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        >
          <ClockCircleOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
          <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
            Theatre Room Events
          </Title>
        </div>
        <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
          <Button
            icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
            onClick={showModal}
            style={{
              background: hexToRGBA(token.colorSuccess, 0.1),
              borderColor: token.colorSuccess,
              color: token.colorSuccess,
              fontWeight: 'bold'
            }}
          >
            Add Event
          </Button>
        </div>
      </div>

      {/* Filters and search */}
      <EventFilters
        searchText={searchText}
        setSearchText={setSearchText}
        roomFilter={roomFilter}
        setRoomFilter={setRoomFilter}
        eventTypeFilter={eventTypeFilter}
        setEventTypeFilter={setEventTypeFilter}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        dateRange={dateRange}
        setDateRange={setDateRange}
        theatreRooms={theatreRooms}
        eventTypes={eventTypes}
      />

      <Tabs defaultActiveKey='table'>
        <TabPane tab='Table View' key='table'>
          <EventsTable data={filteredData} />
        </TabPane>

        <TabPane tab='Timeline View' key='timeline'>
          <TimelineView />
        </TabPane>
      </Tabs>

      {/* Add Event Modal */}
      <AddEventModal
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        handleAdd={handleAdd}
        form={form}
        theatreRooms={theatreRooms}
        eventTypes={eventTypes}
        eventCategories={eventCategories}
      />
    </div>
  )
}

export default TheatreRoomEventsList
